import { env } from "@/lib/core/env";

/**
 * The legal pages live on the website (blanqo-web, src/pages). TERMS_VERSION must equal the
 * website's (src/lib/legal.ts) and server/pb_hooks/lib/account.js, which refuses a sign-up with
 * any other; sign-up stores it with the account.
 */
export const TERMS_VERSION = "2026-10-12";

const SITE = env.siteUrl;
export const LEGAL_URLS = {
  imprint: `${SITE}/imprint`,
  privacy: `${SITE}/privacy`,
  terms: `${SITE}/terms`,
  dpa: `${SITE}/dpa`,
} as const;
